import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useUser } from '../../features/auth/useUser';
import styles from './AuthErrorBanner.module.css';

type AuthErrorBannerProps = {
  error: {
    error?: string;
    message?: string;
    action?: 'reauthenticate' | 'contact_admin';
    redirect_url?: string;
  };
};

/**
 * Amazon認証エラー専用のバナーコンポーネント
 * 管理者とユーザーで異なるメッセージと行動を表示
 */
export function AuthErrorBanner({ error }: AuthErrorBannerProps) {
  const navigate = useNavigate();

  if (!error || !error.action) {
    return null;
  }

  const { isAdmin } = useUser();

  const handleReauthenticate = () => {
    if (error.redirect_url) {
      navigate(error.redirect_url);
    }
  };

  return (
    <div className={styles.authErrorBanner}>
      <div className={styles.icon}>
        <AlertTriangle size={24} aria-hidden="true" />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{error.error}</h3>
        <p className={styles.message}>{error.message}</p>
        {error.action === 'reauthenticate' && isAdmin && (
          <button
            type="button"
            className={styles.actionButton}
            onClick={handleReauthenticate}
          >
            接続設定ページへ移動
          </button>
        )}
      </div>
    </div>
  );
}
